import { useMutation, useQueryClient } from '@tanstack/react-query';
import { appApiAiCenter } from 'configs/variables';
import useHttpClient from 'hooks/useHttpClient';
import { suspectKeys } from '../keys';

// PUT /api/suspects/{suspect_id}
// payload: { name }
export function useUpdateSuspect({ id = '', onSuccess = undefined, onError = undefined } = {}) {
  const { put } = useHttpClient();
  const queryClient = useQueryClient();

  const queryMutation = useMutation({
    mutationKey: suspectKeys.update.queryKey,
    mutationFn: async (payload) => {
      const req = await put({
        url: appApiAiCenter + '/suspects/' + id,
        payload: payload.payload,
      });

      return req;
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: suspectKeys.all._def,
      });

      if (onSuccess) {
        onSuccess(...args);
      }
    },
    onError: (error, ...args) => {
      if (onError) {
        if (!error) return;
        onError(error, ...args);
      }
    },
  });

  return queryMutation;
}
